(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bestsellers-carousel"] && !Shopify.designMode) return;
  try {
    
  class BestsellersCarousel extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.windowEl = this.querySelector('[data-window]');
      this.track = this.querySelector('[data-track]');
      this.heading = this.querySelector('.bestsellers-carousel__heading');
      this.sources = Array.from(this.track?.querySelectorAll(':scope > [data-item]') || []);
      this.prevButton = this.querySelector('[data-prev]');
      this.nextButton = this.querySelector('[data-next]');
      this.centerIndex = 0;
      this.intervalMs = Number(this.dataset.interval) || 4000;
      this.timer = null;
      this.moveTimer = null;
      this.moving = false;
      this.resizeFrame = null;
      this.layoutGeneration = 0;
      this.slotOf = new WeakMap();
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.N = this.sources.length;

      if (!this.windowEl || !this.track || this.N === 0) return;

      this.initialized = true;
      this.pool = this.sources.map((node, productIndex) => {
        node.dataset.productIndex = String(productIndex);
        return { node, productIndex, copy: 0 };
      });

      this.onPrev = () => this.go(-1);
      this.onNext = () => this.go(1);
      this.onResize = () => {
        if (this.resizeFrame) return;
        this.resizeFrame = window.requestAnimationFrame(() => {
          this.resizeFrame = null;
          if (this.isConnected) this.layout(false);
        });
      };

      this.prevButton?.addEventListener('click', this.onPrev);
      this.nextButton?.addEventListener('click', this.onNext);
      window.addEventListener('resize', this.onResize);
      this.resizeObserver = new ResizeObserver(this.onResize);
      this.resizeObserver.observe(this.windowEl);

      this.layout(false);
      document.fonts?.ready.then(() => {
        if (this.isConnected && !this.moving) this.layout(false);
      });
      this.play();
    }

    disconnectedCallback() {
      this.pause();
      if (this.moveTimer) window.clearTimeout(this.moveTimer);
      if (this.resizeFrame) window.cancelAnimationFrame(this.resizeFrame);
      this.prevButton?.removeEventListener('click', this.onPrev);
      this.nextButton?.removeEventListener('click', this.onNext);
      window.removeEventListener('resize', this.onResize);
      this.resizeObserver?.disconnect();
      for (const entry of this.pool || []) {
        if (entry.copy > 0) entry.node.remove();
      }
      this.initialized = false;
      this.moving = false;
    }

    play() {
      if (this.reducedMotion || this.N < 2) return;
      this.pause();
      this.timer = window.setInterval(() => this.go(1, false), this.intervalMs);
    }

    pause() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    mod(value, count) {
      return ((value % count) + count) % count;
    }

    go(step, resetTimer = true) {
      if (this.N < 2) return;

      if (this.moving) {
        this.layout(false);
        this.windowEl.getBoundingClientRect();
      }

      this.centerIndex = this.mod(this.centerIndex + step, this.N);
      this.moving = !this.reducedMotion;
      this.layout(true);

      if (this.moveTimer) window.clearTimeout(this.moveTimer);
      this.moveTimer = window.setTimeout(() => {
        this.moving = false;
      }, 600);

      if (resetTimer) this.play();
    }

    toPx(value) {
      const raw = String(value || '').trim();
      if (!raw) return 0;
      if (raw.endsWith('px')) return parseFloat(raw);
      const probe = document.createElement('div');
      probe.style.position = 'absolute';
      probe.style.visibility = 'hidden';
      probe.style.pointerEvents = 'none';
      probe.style.width = raw;
      this.appendChild(probe);
      const px = probe.getBoundingClientRect().width;
      probe.remove();
      return px;
    }

    headingCenterInWindow() {
      const windowRect = this.windowEl.getBoundingClientRect();
      if (!this.heading) return windowRect.width / 2;

      const range = document.createRange();
      range.selectNodeContents(this.heading);
      const textRect = range.getBoundingClientRect();
      const rect = textRect.width > 0 ? textRect : this.heading.getBoundingClientRect();
      return rect.left + rect.width / 2 - windowRect.left;
    }

    readMetrics() {
      const styles = getComputedStyle(this);
      const itemSize = this.toPx(styles.getPropertyValue('--item-size'));
      const sideScale = Number(styles.getPropertyValue('--item-scale-side')) || 0.38;
      const activeScale = Number(styles.getPropertyValue('--item-scale-active')) || 1.26;
      const gap = this.toPx(styles.getPropertyValue('--carousel-gap'));
      const side = itemSize * sideScale;
      const active = itemSize * activeScale;
      const pitch = Math.max(1, side + gap);
      const windowRect = this.windowEl.getBoundingClientRect();
      const centerX = this.headingCenterInWindow();
      const leftSpace = Math.max(0, centerX - active / 2);
      const rightSpace = Math.max(0, windowRect.width - centerX - active / 2);
      const sideCount = Math.max(1, Math.ceil(Math.max(leftSpace, rightSpace) / pitch) + 1);

      return { itemSize, sideScale, activeScale, gap, side, active, sideCount, centerX };
    }

    xForOffset(k, metrics) {
      if (k === 0) return 0;
      const dir = Math.sign(k);
      const steps = Math.abs(k);
      const first = metrics.active / 2 + metrics.gap + metrics.side / 2;
      const extra = (steps - 1) * (metrics.side + metrics.gap);
      return dir * (first + extra);
    }

    ensureCopies(copies) {
      for (let productIndex = 0; productIndex < this.N; productIndex++) {
        let have = this.pool.filter((entry) => entry.productIndex === productIndex).length;
        const source = this.sources[productIndex];
        while (have < copies) {
          const node = source.cloneNode(true);
          node.dataset.productIndex = String(productIndex);
          node.classList.remove('is-active');
          node.style.transition = 'none';
          this.track.appendChild(node);
          this.pool.push({ node, productIndex, copy: have });
          have += 1;
        }
      }
    }

    layout(animate) {
      if (!this.windowEl || this.N === 0) return;
      if (this.windowEl.getBoundingClientRect().width < 1) return;

      const metrics = this.readMetrics();
      const slotCount = metrics.sideCount * 2 + 1;
      this.ensureCopies(Math.ceil(slotCount / this.N));

      const slots = [];
      for (let k = -metrics.sideCount; k <= metrics.sideCount; k++) {
        slots.push({
          k,
          productIndex: this.mod(this.centerIndex + k, this.N),
        });
      }

      const used = new Set();
      const assignments = [];
      for (const slot of slots) {
        const candidates = this.pool.filter(
          (entry) => entry.productIndex === slot.productIndex && !used.has(entry.node)
        );
        let best = candidates[0];
        let bestScore = Infinity;
        for (const entry of candidates) {
          const prev = this.slotOf.get(entry.node);
          const dist = prev == null ? null : Math.abs(prev - slot.k);
          const score = dist == null ? 5000 + entry.copy : dist > 1 ? 8000 + dist : dist;
          if (score < bestScore) {
            bestScore = score;
            best = entry;
          }
        }
        if (!best) continue;
        used.add(best.node);
        const prev = this.slotOf.get(best.node);
        assignments.push({
          node: best.node,
          k: slot.k,
          jumped: prev == null || Math.abs(prev - slot.k) > 1,
        });
      }

      const shouldAnimate = animate && !this.reducedMotion;
      const jumpedNodes = [];
      const nextSlots = new WeakMap();

      for (const assignment of assignments) {
        const tx = metrics.centerX + this.xForOffset(assignment.k, metrics) - metrics.itemSize / 2;
        const scale = assignment.k === 0 ? metrics.activeScale : metrics.sideScale;
        const node = assignment.node;
        if (!shouldAnimate || assignment.jumped) {
          node.style.transition = 'none';
          jumpedNodes.push(node);
        } else {
          node.style.transition = '';
        }
        node.hidden = false;
        node.inert = false;
        node.style.visibility = '';
        node.style.pointerEvents = '';
        node.style.transform = `translate3d(${tx}px, -50%, 0) scale(${scale})`;
        node.classList.toggle('is-active', assignment.k === 0);
        node.dataset.placed = 'true';
        nextSlots.set(node, assignment.k);
      }

      for (const entry of this.pool) {
        if (used.has(entry.node)) continue;
        entry.node.classList.remove('is-active');
        entry.node.inert = true;
        entry.node.style.visibility = 'hidden';
        entry.node.style.pointerEvents = 'none';
        delete entry.node.dataset.placed;
      }

      this.slotOf = nextSlots;
      this.classList.add('is-ready');

      if (!jumpedNodes.length) return;

      this.layoutGeneration += 1;
      const generation = this.layoutGeneration;
      const restore = () => {
        if (generation !== this.layoutGeneration) return;
        for (const node of jumpedNodes) node.style.transition = '';
      };

      if (shouldAnimate) {
        this.windowEl.getBoundingClientRect();
        window.requestAnimationFrame(restore);
      } else {
        this.windowEl.getBoundingClientRect();
        restore();
      }
    }
  }

  if (!customElements.get('bestsellers-carousel')) {
    customElements.define('bestsellers-carousel', BestsellersCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mission-statement"] && !Shopify.designMode) return;
  try {
    
  class MissionStatement extends HTMLElement {
    connectedCallback() {
      if (this.dataset.animate !== 'true') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.classList.add('is-pending');

      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;

          this.classList.remove('is-pending');
          this.classList.add('is-visible');
          this.observer.disconnect();
        },
        { threshold: 0.2, rootMargin: '0px 0px -8% 0px' }
      );

      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  if (!customElements.get('mission-statement')) {
    customElements.define('mission-statement', MissionStatement);
  }

  } catch(e) { console.error(e); }
})();
})();
